/** @flow */

import {
  GetDataSecurityGeneralSettingsSuccess,
  GetDataSecurityGeneralSettingsError,
  ToggleSystemAccessPasswordResetModal,
  ToggleSystemAccessLogOutLockModal,
  ToggleAddIpRestrictionModal,
  ToggleClientLogoModal,
  ToggleRegistrationEmailsModal,
  GetClientLogoSuccess,
  GetClientLogoError,
  GetBulkRegistrationEmailsSuccess,
  GetPlatformDataSecuritySuccess,
  GetPlatformDataSecurityError,
  ToggleStandardRegistrationEmailsModal,
  ToggleRegistrationEmailsExportModal,
  GetEmployeeRegistrationEmailsTargetsSuccess,
  ToggleEmployeeRegistrationEmailsModal,
  GetBulkRegistrationEmailsTargets,
  GetBulkRegistrationEmailsTargetsSuccess,
  GetBulkRegistrationEmailsTargetsError,
  UpdateRegistrationEmails,
  UpdateRegistrationEmailsSuccess,
  UpdateRegistrationEmailsError,
  UpdateDataSecurityGeneralSettings,
  UpdateDataSecurityGeneralSettingsSuccess,
  UpdateDataSecurityGeneralSettingsError,
  SendBulkRegistrationEmails,
  SendBulkRegistrationEmailsSuccess,
  SendBulkRegistrationEmailsError,
  SendEmployeeRegistrationEmails,
  SendEmployeeRegistrationEmailsSuccess,
  SendEmployeeRegistrationEmailsError,
} from "@modules/service/constants/actions";
import * as systemAccessReducers from "./reducers";
import initialState from "./state";
import type { SystemAccessState } from "./types";
import { cloneObject } from "@utils/object";

export default (state: SystemAccessState = initialState, action: Object): SystemAccessState => {
  const act = {
    [GetDataSecurityGeneralSettingsSuccess]:
      systemAccessReducers.onGetDataSecurityGeneralSettingsSuccess,
    [GetDataSecurityGeneralSettingsError]:
      systemAccessReducers.onGetDataSecurityGeneralSettingsError,
    [ToggleSystemAccessPasswordResetModal]:
      systemAccessReducers.onToggleSystemAccessPasswordResetModal,
    [ToggleSystemAccessLogOutLockModal]: systemAccessReducers.onToggleSystemAccessLogOutLockModal,
    [ToggleAddIpRestrictionModal]: systemAccessReducers.onToggleAddIpRestrictionModal,
    [ToggleClientLogoModal]: systemAccessReducers.onToggleClientLogoModal,
    [ToggleRegistrationEmailsModal]: systemAccessReducers.onToggleRegistrationEmailsModal,
    [ToggleEmployeeRegistrationEmailsModal]:
      systemAccessReducers.onToggleEmployeeRegistrationEmailsModal,
    [ToggleRegistrationEmailsExportModal]:
      systemAccessReducers.onToggleRegistrationEmailsExportModal,
    [GetClientLogoSuccess]: systemAccessReducers.onGetClientLogoSuccess,
    [GetClientLogoError]: systemAccessReducers.onGetClientLogoError,
    [GetBulkRegistrationEmailsSuccess]: systemAccessReducers.onGetBulkRegistrationEmailsSuccess,
    [GetBulkRegistrationEmailsTargets]: systemAccessReducers.onGetBulkRegistrationEmailsTargets,
    [GetBulkRegistrationEmailsTargetsSuccess]:
      systemAccessReducers.onGetBulkRegistrationEmailsTargetsSuccess,
    [GetBulkRegistrationEmailsTargetsError]:
      systemAccessReducers.onGetBulkRegistrationEmailsTargetsError,
    [GetPlatformDataSecuritySuccess]: systemAccessReducers.onGetPlatformDataSecuritySuccess,
    [GetPlatformDataSecurityError]: systemAccessReducers.onGetPlatformDataSecurityError,
    [ToggleStandardRegistrationEmailsModal]:
      systemAccessReducers.onToggleStandardRegistrationEmailsModal,
    [GetEmployeeRegistrationEmailsTargetsSuccess]:
      systemAccessReducers.onGetEmployeeRegistrationEmailsTargetsSuccess,
    [UpdateRegistrationEmails]: systemAccessReducers.onUpdateRegistrationEmails,
    [UpdateRegistrationEmailsSuccess]: systemAccessReducers.onUpdateRegistrationEmailsSuccess,
    [UpdateRegistrationEmailsError]: systemAccessReducers.onUpdateRegistrationEmailsError,
    [UpdateDataSecurityGeneralSettings]: systemAccessReducers.onUpdateDataSecurityGeneralSettings,
    [UpdateDataSecurityGeneralSettingsSuccess]:
      systemAccessReducers.onUpdateDataSecurityGeneralSettingsSuccess,
    [UpdateDataSecurityGeneralSettingsError]:
      systemAccessReducers.onUpdateDataSecurityGeneralSettingsError,

    [SendBulkRegistrationEmails]: systemAccessReducers.setLoading,
    [SendBulkRegistrationEmailsSuccess]: systemAccessReducers.setLoaded,
    [SendBulkRegistrationEmailsError]: systemAccessReducers.setLoaded,
    [SendEmployeeRegistrationEmails]: systemAccessReducers.setLoading,
    [SendEmployeeRegistrationEmailsSuccess]: systemAccessReducers.setLoaded,
    [SendEmployeeRegistrationEmailsError]: systemAccessReducers.setLoaded,
  };
  if (action && action.type && act && act[action.type]) {
    return act[action.type](cloneObject(state))(action);
  }
  return state;
};
